module.exports = __webpack_public_path__ + "img/ES0219.df58eb00.png";